/*
 * Van ruwe productgegevens naar de vorm waar het quizmodel mee rekent.
 *
 * Dit bestand wordt door TWEE dingen gebruikt: door scripts/bouw-geurindex.mjs,
 * dat er een geurindex.json van maakt, en door de quiz in de browser, die de
 * producten rechtstreeks uit de pagina leest. Dat is met opzet één bestand.
 * Stonden er twee versies van deze regels, dan zou de quiz op een dag andere
 * geuren aanraden dan het bestand -- en dat merk je pas als een klant iets
 * krijgt wat niet klopt.
 *
 * Hier staat geen enkele keuze hardcoded: welk label bij welke familie hoort,
 * wat "Day" betekent, hoe lang "Strong" meegaat -- dat staat allemaal in
 * quiz-config.json. Dit bestand vertaalt alleen.
 */
(function (wortel, fabriek) {
  var api = fabriek();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else wortel.SentirGeurIndex = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  /*
   * Dezelfde noot staat er in meer dan één schrijfwijze: "Tonka Bean" naast
   * "Tonka bean", "Woody notes" naast "Woody Notes". Voor het scoren tellen die
   * als één, anders mist een klant die tonka koos de helft van de tonkageuren.
   */
  function sleutelVan(noot) {
    return String(noot)
      .toLowerCase()
      .replace(/[‘’']/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function splitsNoten(tekst) {
    return String(tekst || '')
      .split(/[,;/]/)
      .map(function (n) { return n.trim(); })
      .filter(Boolean);
  }

  function vertaal(tabel, waarde, terugval) {
    if (!waarde) return terugval;
    var gevonden = (tabel || {})[String(waarde).trim()];
    return gevonden === undefined ? terugval : gevonden;
  }

  /*
   * Warm of fris komt bij voorkeur van het product zelf: de winkel tagt elke
   * geur met Warm of Fresh, en dat oordeel is beter dan wat je uit de familie
   * afleidt. Een kruidige geur kan alsnog fris zijn en een musk kan allebei --
   * dat hangt van de geur af, niet van zijn familie.
   *
   * Gemeten op 115 geuren: de tag geeft 106 keer een oordeel, de afleiding uit
   * de familie maar 80, en bij 18 geuren spraken ze elkaar tegen. Daar had de
   * tag gelijk. De afleiding blijft als terugval voor wie geen tag heeft.
   */
  function warmteVan(families, config, tag) {
    if (tag === 'Warm' || tag === 'Fris') return tag;

    var warm = (config.warmte && config.warmte.warm) || [];
    var fris = (config.warmte && config.warmte.fris) || [];
    var lijst = [].concat(families || []);

    var isWarm = lijst.some(function (f) { return warm.indexOf(f) > -1; });
    var isFris = lijst.some(function (f) { return fris.indexOf(f) > -1; });

    /* Allebei of geen van beide: dan zegt dit veld niets en blijft het leeg. */
    if (isWarm === isFris) return null;
    return isWarm ? 'Warm' : 'Fris';
  }

  /*
   * De uitklaptekst mag niet beginnen met de zin die al op de kaart staat --
   * dan staat dezelfde regel twee keer, zestig pixel uit elkaar.
   *
   * Bewust zonder lookbehind in de regex: die kent niet elke browser die we
   * bedienen, en een quiz die op één telefoon leeg blijft is erger dan een
   * zin die een keer dubbel staat.
   */
  function langeTekst(lang, kort) {
    var heel = String(lang || '').trim();
    var korte = String(kort || '').trim();
    if (!heel || !korte) return heel;

    var m = heel.match(/^[\s\S]*?[.!?](?=\s|$)/);
    var eersteZin = m ? m[0] : '';
    if (eersteZin && eersteZin.toLowerCase().indexOf(korte.slice(0, 40).toLowerCase()) === 0) {
      return heel.slice(eersteZin.length).trim();
    }
    return heel;
  }

  /* Een bestandsnaam uit een metafield is nog geen URL. */
  function cdn(waarde, winkel) {
    var w = String(waarde);
    /*
     * Protocolloze urls (//cdn...) breken zodra de pagina niet via https
     * draait -- in een testopstelling op file:// zoekt de browser dan een map
     * met die naam. Altijd https ervoor dus.
     */
    if (w.indexOf('//') === 0) return 'https:' + w;
    if (w.indexOf('http') === 0) return w;
    return (winkel || 'https://sentirparfum.com') + '/cdn/shop/' + w.replace(/^\/+/, '');
  }

  /* De stijlpil: label uit de winkel, kleur en icoon uit het ontwerp. */
  function pil(naam, config) {
    var sleutel = config.palet.stijl_naar_familie[String(naam).trim()];
    var kleur = sleutel ? config.palet.families[sleutel] : null;
    var uit = { label: String(naam).trim(), familie: sleutel || null };
    if (kleur) {
      Object.keys(kleur).forEach(function (k) { uit[k] = kleur[k]; });
    }
    return uit;
  }

  /*
   * Vier momenten uit twee. De winkel kent alleen Day en Night; het ontwerp
   * toont Everyday, Work, Evening en Date. De koppeling staat in de config,
   * want het is een redactionele keuze en geen meting.
   */
  function momentenVan(gelegenheid, config) {
    var tabel = config.past_bij.moment_uit_gelegenheid;
    var nl = config.waarden.gelegenheid[String(gelegenheid || '').trim()];
    return tabel[nl] || [];
  }

  function seizoenen(tekst, tabel) {
    var uit = [];
    splitsNoten(tekst).forEach(function (s) {
      var v = vertaal(tabel, s, null);
      if (v && uit.indexOf(v) === -1) uit.push(v);
    });
    return uit;
  }

  /* Welke families een geur bereikbaar maken, inclusief de 'ook'-sleutels. */
  function reik(regel) {
    if (!regel) return [];
    var uit = [];
    [regel.primair].concat(regel.ook || []).forEach(function (f) {
      if (f && uit.indexOf(f) === -1) uit.push(f);
    });
    return uit;
  }

  /*
   * Eén ruwe rij naar één geur. `notenTeller` verzamelt onderweg de nette
   * schrijfwijze per notensleutel, zodat de quiz "tonka bean" als "Tonka Bean"
   * kan tonen.
   */
  function geurVan(p, config, notenTeller, onbekend, winkel) {
    var primairRuw = (p.label1 || '').trim();
    var secundairRuw = (p.label2 || '').trim();

    var familieRegel = config.families[primairRuw];
    var secundairRegel = config.families[secundairRuw];

    if (primairRuw && !familieRegel && onbekend) onbekend.push(primairRuw);
    if (secundairRuw && !secundairRegel && onbekend) onbekend.push(secundairRuw);

    var bereikPrimair = reik(familieRegel);
    var bereikSecundair = reik(secundairRegel);
    var bereikbaar = [];
    bereikPrimair.concat(bereikSecundair).forEach(function (f) {
      if (bereikbaar.indexOf(f) === -1) bereikbaar.push(f);
    });

    var noten = {};
    [['top', 'notenTop'], ['hart', 'notenHart'], ['basis', 'notenBasis']].forEach(function (paar) {
      noten[paar[1]] = splitsNoten(p[paar[0]]).map(function (n) {
        var sleutel = sleutelVan(n);
        if (notenTeller && !(sleutel in notenTeller)) notenTeller[sleutel] = n;
        return sleutel;
      });
    });

    var gelegenheid = [];
    var moment = vertaal(config.waarden.gelegenheid, p.gelegenheid, null);
    if (moment) gelegenheid.push(moment);
    seizoenen(p.seizoen, config.waarden.seizoen).forEach(function (s) { gelegenheid.push(s); });

    var geur = {
      handle: p.handle,
      /* Voor de Stamped-reviewwidget op de uitslagkaart; die zoekt op id. */
      id: p.id || null,
      titel: p.titel,
      prijs: p.prijs,
      variant: p.variant,
      afbeelding: p.afbeelding ? cdn(p.afbeelding, winkel) : null,
      kort: (p.kort || '').trim(),
      lang: langeTekst(p.beschrijving, p.kort),
      rating: Number(p.rating) || null,
      ratingAantal: Number(p.ratingAantal) || null,
      flesje: p.flesje ? cdn(p.flesje, winkel) : null,
      stijlen: [p.label1, p.label2].filter(Boolean).map(function (naam) { return pil(naam, config); }),
      seizoenen: seizoenen(p.seizoen, config.waarden.seizoen),
      momenten: momentenVan(p.gelegenheid, config),
      familiePrimair: familieRegel ? familieRegel.primair : null,
      familieSecundair: secundairRegel ? secundairRegel.primair : null,
      /*
       * Twee lijsten en niet één: een treffer op de primaire familie is 23
       * punten waard en op de secundaire 12, en dat verschil moet het model
       * kunnen zien.
       */
      bereikPrimair: bereikPrimair,
      bereikSecundair: bereikSecundair,
      families: bereikbaar,
      warmte: warmteVan(bereikbaar, config, p.warmteTag),
      /*
       * Herkenbaar of eigenzinnig, uit de tag `Unique` van de winkel. Geen tag
       * betekent herkenbaar: de ongetagde helft is de bloemige publiekskant
       * (Floral Elegance, Peony Heaven, Glamorous Bouquet) en de getagde de
       * uitgesprokene (Santal Haze, Metallic Saffron, Tobacco Sultan).
       */
      karakter: p.karakter === 'Eigenzinnig' ? 'Eigenzinnig' : 'Herkenbaar',
      sillage: vertaal(config.waarden.sillage, p.icoon4, null),
      gender: vertaal(config.waarden.gender, p.icoon3, 'Neutraal'),
      gelegenheid: gelegenheid,
      /*
       * De populariteitsrem staat uit (straffen.populariteit = 0), dus dit veld
       * doet niets. Het blijft staan zodat de rem terug kan zonder dat de vorm
       * van de index verandert.
       */
      slot1Aandeel: 0,
      longevity: vertaal(config.waarden.longevity, p.icoon4, null),
    };

    Object.keys(noten).forEach(function (k) { geur[k] = noten[k]; });
    return geur;
  }

  /*
   * Alle ruwe rijen naar een complete index. Levert er ook bij op wat er
   * ontbreekt -- die klachten zijn het enige wat je nog waarschuwt zodra het
   * bouwscript er niet meer tussen zit.
   */
  var VERPLICHT = ['handle', 'titel', 'prijs', 'variant', 'familiePrimair', 'notenBasis'];

  function normaliseer(rijen, config, opties) {
    var o = opties || {};
    var notenTeller = {};
    var onbekend = [];
    var klachten = [];

    var geuren = (rijen || []).map(function (p) {
      return geurVan(p, config, notenTeller, onbekend, o.winkel);
    });

    geuren.forEach(function (g) {
      VERPLICHT.forEach(function (veld) {
        var w = g[veld];
        var leeg = w === null || w === undefined || w === '' ||
                   (Array.isArray(w) && w.length === 0);
        if (leeg) klachten.push({ handle: g.handle || '?', titel: g.titel || '?', veld: veld });
      });
    });

    var uniekOnbekend = [];
    onbekend.forEach(function (f) { if (uniekOnbekend.indexOf(f) === -1) uniekOnbekend.push(f); });

    return {
      aantal: geuren.length,
      notenNamen: notenTeller,
      geuren: geuren,
      klachten: klachten,
      onbekendeFamilies: uniekOnbekend,
    };
  }

  return {
    normaliseer: normaliseer,
    geurVan: geurVan,
    sleutelVan: sleutelVan,
    splitsNoten: splitsNoten,
    vertaal: vertaal,
    warmteVan: warmteVan,
    langeTekst: langeTekst,
    cdn: cdn,
    pil: pil,
    momentenVan: momentenVan,
    seizoenen: seizoenen,
    VERPLICHT: VERPLICHT,
  };
});
